module.exports = __webpack_public_path__ + "img/ufos.b5487136.gif";